import type { Measurable } from '@radix-ui/rect';
import { Popover, PopoverAnchor, PopoverContent } from '@talentmesh/ui/components/popover';
import React, { useMemo } from 'react';

import CompanyDetail, { CompanyDetailProps } from './CompanyDetail';

type AiSearchCompanyDetailProps = Omit<CompanyDetailProps, 'onCloseIconClick'> & {
    open: boolean;
    onClose?: () => void;
    anchorEl: HTMLElement | null | undefined;
};

const AiSearchCompanyDetail = ({
    companyDomain,
    companyName,
    companyLinkedInUrl,
    open,
    onClose,
    anchorEl,
}: AiSearchCompanyDetailProps) => {
    const virtualAnchorRef = useMemo<React.RefObject<Measurable>>(
        () => ({ current: anchorEl as Measurable }),
        [anchorEl],
    );

    return (
        <Popover open={open} onOpenChange={(isOpen) => !isOpen && onClose?.()}>
            {anchorEl ? <PopoverAnchor virtualRef={virtualAnchorRef} /> : null}
            <PopoverContent
                side="bottom"
                align="start"
                sideOffset={4}
                className="w-auto max-w-none gap-0 p-0"
                onOpenAutoFocus={(event) => event.preventDefault()}
            >
                <CompanyDetail
                    companyDomain={companyDomain}
                    companyName={companyName}
                    companyLinkedInUrl={companyLinkedInUrl}
                    onCloseIconClick={onClose}
                />
            </PopoverContent>
        </Popover>
    );
};

export default AiSearchCompanyDetail;
